import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { GatewayDTO } from 'src/app/core/models/gateway';
import { GatewayService } from '../../../../../../core/services/gateway.service';

@Component({
  selector: 'app-attach-gateway',
  templateUrl: './attach-gateway.component.html',
  styleUrls: ['./attach-gateway.component.scss']
})
export class AttachGatewayComponent implements OnInit {

  updateGatewayForm: UntypedFormGroup;
  gateways: GatewayDTO[] = [];
  gate

  constructor(@Inject(MAT_DIALOG_DATA) public data: { oldGw: string, nodeName: string },
    public dialog: MatDialogRef<AttachGatewayComponent>,
    private gatewayService: GatewayService,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.getGateways();
    this.updateGatewayForm = new UntypedFormGroup({
      gateway: new UntypedFormControl(this.data.oldGw, this.updateGatewayForm)
    })
  }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit(form) {
    if (form.status == "INVALID") {
      this.updateGatewayForm.markAllAsTouched();
      return;
    }
    else {
      this.gatewayService.updateGatewayForVM(this.data.nodeName, form.value.gateway)
        .subscribe({
          next: (data: any) => {
            this.snackBar.open("Updated Gateway", 'Ok', { duration: 5000 });
          },
          error: (err: any) => {
            this.snackBar.open("Could Not Update Gateway", 'Ok', { duration: 5000 });
          }
        });
      this.dialog.close();
    }
  }

  getGateways() {
    this.gatewayService.getAllGateways()
      .subscribe({
        next: (data) => {
          this.gateways = <GatewayDTO[]>(data);
          this.spinner.hide();
        },
        error: () => {

        },
        complete: () => {

        },
      });
  }

}
